import { Injectable, inject } from '@angular/core';
import { CustomerService } from '../services/customer.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private customerService = inject(CustomerService);

  isAuthenticated() {
    return this.customerService.loggedCustomer$;
  }
}
